// Which deployment this build serves, fixed at build time by
// REACT_APP_SITE_ENV (the API URL is baked in the same way). Only the staging
// build sets it; production and local builds leave it unset and look normal.
export const SITE_ENV = process.env.REACT_APP_SITE_ENV || '';

export const IS_STAGING = SITE_ENV === 'staging';
